export class ApplicationClaim {
    applicationClaimId: string;
    name: string;
    isSelected: boolean;
    description: string;
    statusCode: string;
    isDefault: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/applicationClaim.ts